import React from "react";
import '../../Styles/Footer.css'
import{ NavLink} from 'react-router-dom'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Axios from "axios";

class FooterWallmag extends React.Component {

      constructor(props){
            super(props)

            this.state = {
                  data : ''
            }
      }

      componentDidMount(){

      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+localStorage.user
        }

        Axios.get('https://wallmag-2.appspot.com/_ah/api/bannerApi/v1/listAllByOrderWeb',{
              headers:headers
        }).then(res=>{
              this.setState({
                   data : res.data
              });
        })
      }

      // Redirect Page
      goToPage=(url)=>{
            window.open(url,'_blank')
      }

  render() {
    return (
      <div className='container-fluid foot_div'>

      <Carousel 
                  useKeyboardArrows={true} autoPlay={true} infiniteLoop={true} 
                  showArrows={true} showThumbs={false} showIndicators={false} interval={7000}
                 
                >
                      {
                            this.state.data.items ? 
                            this.state.data.items.map(res=>{
                                  return(
                                        <div style={{cursor:'pointer', width:`${window.innerWidth}px`}} onClick={e=>this.goToPage(res.webRedirectUrl)}>
                                              {
                                                    window.innerWidth<992 ? 

                                                    <img 
                                                    className='img-fluid'
                                                    src={res.imageMobileUrl} 
                                                    alt='webImage'
                                                    style={{padding:'0px'}}
                                                    />
                                                    :
                                                    window.innerWidth < 1440 ? 
                                                    <img 
                                                    className='img-fluid'
                                                    src={res.imageWebUrl} 
                                                    alt='webImage'
                                                    style={{
                                                          paddingTop:'50px',
                                                          paddingBottom:'50px',
                                                          
                                                    }}
                                                    />
                                                    :

                                                    <img 
                                                    className='img-fluid'
                                                    src={res.imageWebUrl} 
                                                    alt='webImage'
                                                    style={{
                                                          paddingTop:'50px',
                                                          paddingBottom:'50px',
                                                          paddingLeft:`${window.innerWidth*15/100}px`,
                                                          paddingRight:`${window.innerWidth*15/100}px`
                                                    }}
                                                    />

                                              }
                                       
                                          </div>
                                  )
                            })
                            : ''
                      }
      </Carousel>                


            <img id='logo' width='' src={require('../../logo/wallmag_white.png')} alt='Logo' />
            <div className='row'>
            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4 wallmag'>WallMag</div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 wallmag_sub_title'>Where Photos Meet Stories</div>
     
      <div className='col-2 col-sm-2 col-md-3 col-lg-3 col-xl-3 mt-2 '></div>
      <div className='col-8 col-sm-8 col-md-6 col-lg-6 col-xl-6 wallmag_desc'>
      We are a community and marketplace for real photography.
      We organize prestigious photography awards bringing best photographers to a huge audience.

      </div>
      <div className='col-2 col-sm-2 col-md-3 col-lg-3 col-xl-3 mt-2 '></div>

      <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 justify-content-center'>

           {/* Instagram */}
                <a href='https://www.instagram.com/wallmag_app/' target='_blank' rel="noopener noreferrer">
                      <img id='sc_links' src={require('../../logo/insta.svg')} alt='Instagram Logo' />
                  </a>

           {/* facebook */}
           <a href='https://www.facebook.com/wallmag.io/' target='_blank' rel="noopener noreferrer">
                    <img id='sc_links' src={require('../../logo/fb.svg')} alt='Facebook Logo' />
                  </a>
            
            {/* LinkedIn */}
            <a href='https://www.linkedin.com/company/wallmag' target='_blank' rel="noopener noreferrer">
                        <img id='sc_links' src={require('../../logo/lnk.svg')} alt='Linkedin Logo' />
                  </a>
            
            {/* twitter */}
              <a href='https://twitter.com/wallmag_io' target='_blank' rel="noopener noreferrer">
                    <img id='sc_links' src={require('../../logo/tw.svg')} alt='Twitter Logo' />
                  </a>
       
            
            {/* Pinterest */}
              <a href='https://in.pinterest.com/wallmag_app/' target='_blank' rel="noopener noreferrer">
                    <img id='sc_links' src={require('../../logo/pin.svg')} alt='Pinterest Logo' />
                  </a>

             {/* tumblr */}
             <a href='https://wallmag-app.tumblr.com/' target='_blank' rel="noopener noreferrer">
                     <img id='sc_links' src={require('../../logo/tmb.svg')} alt='Tumblr Logo' /> 
                  </a>
        
              
        
      
      </div>

   <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 div_link'>
   <div className='row  justify-content-center'>


   <div className='container'>
     <div className='row'>  
       <div className='col-xl-2 col-lg-2 col-md-2'></div>

        <div className='col-4 col-sm-4 col-xl-3 col-lg-3 col-md-3'>
            
            <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/'>
                  <p id='links'> The Company </p>
            </NavLink>

            <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/about-us'>
                  <p className='sub_links'> About us </p>
            </NavLink>
            
            <a style={{ textDecoration: 'none' }} target='_blank' href='/team-wallmag'>
                  <p className='sub_links'> The Team </p>
            </a>
            
            <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/download-app'>
                  <p className='sub_links'> Our App </p>
            </NavLink>
            

            <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/faq'>
                  <p className='sub_links'> FAQ </p>
            </NavLink>
          
        
        </div>

        <div className='col-4 col-sm-4 col-xl-2 col-lg-2 col-md-2'>

            <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/'>
                  <p id='links'> Contact us </p>
            </NavLink>

            <a style={{ textDecoration: 'none' }} href='https://tawk.to/chat/5dcbea87d96992700fc73ae3/default' target='_blank' rel="noopener noreferrer">
                  <p className='sub_links'> Get in Touch </p>
            </a>

             <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/'>
                  <p className='sub_links'> Advertise </p>
            </NavLink>

            <a style={{ textDecoration: 'none' }} href='https://angel.co/company/wallmag/jobs' target="_blank" rel="noopener noreferrer">
                  <p className='sub_links'> Careers </p>
            </a>

        </div>

        <div className='col-4 col-sm-4 col-xl-3 col-lg-3 col-md-3'>
      
            <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/'>
                  <p id='links'> Legal </p>
            </NavLink>

            <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/privacy-policy'>
                  <p className='sub_links'> Privacy Policy </p>
            </NavLink>

            <NavLink style={{ textDecoration: 'none' }} target='_blank' to='/terms-of-use'>
                  <p className='sub_links'> Terms of Use </p>
            </NavLink>

        </div>

             <div className='col-xl-2 col-lg-2 col-md-2'></div>

         </div>
        </div>
       </div>
      </div>

            
            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>

                  <p  className='sub_links' style={{fontSize:'12px'}}>
                        &copy; 2020 WallMag Global Pvt Ltd
                  </p>

            </div>      

     </div>
    </div>
       
    
    );
  }
}
export default FooterWallmag;